<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'purchase'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">Purchase Spread Package List</h1>
						</div>

						<div class="product-infos-wrapper-pc">
							<el-table :data="planOrderList" stripe style="width: 100%" v-loading="tableLoading">
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="planName" label="Package"></el-table-column>
								<el-table-column prop="planMoney" label="Package Price"></el-table-column>
								<el-table-column prop="startTime" label="Purchase time"></el-table-column>
								<el-table-column prop="endTime" label="Expiration time"></el-table-column>
								<el-table-column label="Payment Type">
									<el-tag type="success">Published</el-tag>
								</el-table-column>
							</el-table>
						</div>

						<div class="product-infos-wrapper-mobile">
							<el-table :data="planOrderList" style="width: 100%" v-loading="tableLoading">
								<el-table-column type="expand">
									<template v-slot="scope">
										<div class="expanded-content">
											<p><strong>Package Price:</strong>&nbsp;&nbsp; {{ scope.row.planMoney }}</p>
											<p><strong>Purchase time:</strong>&nbsp;&nbsp; {{ scope.row.startTime }}</p>
											<p><strong>Expiration time:</strong> &nbsp;&nbsp; {{ scope.row.endTime }}
											</p>
											<p><strong>Payment Type:</strong>&nbsp;&nbsp; <el-tag type="success">
													Published</el-tag>
											</p>
										</div>
									</template>
								</el-table-column>
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="planName" label="Package"></el-table-column>
							</el-table>
						</div>
						<!-- 分页组件 -->
						<div class="page-contrainer d-flex">
							<el-pagination background :page-count="isMobile ? 4 : 10" layout="prev, pager, next"
								:total="tableTotal" :current-page.sync="pageNo" @current-change="handleCurrentChange"
								@prev-click="handlePrevClick" @next-click="handleNextClick"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		planOrderList
	} from '../../api/level'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				tableLoading: false,
				planOrderList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				total: 1,
				pageNo: 1,
				isMobile:false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getPlanOrderList();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			getPlanOrderList() {
				planOrderList(this.queryParams).then(res => {
					if (res.code == 200) {
						this.planOrderList = res.rows;
						this.total = res.total;
					} else {
						return false;
					}
				})
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/review.css");
</style>
<style scoped>
	.product-infos-wrapper-mobile {
		display: none;
	}

	.product-infos-wrapper-pc {
		display: block;
	}

	@media (max-width: 768px) {
		.product-infos-wrapper-mobile {
			display: block;
		}

		.product-infos-wrapper-pc {
			display: none;
		}

	}

	.expanded-content {
		margin: 0 20px;
	}
</style>
